import React, { JSX } from "react";
import { MantineProvider } from "@mantine/core";
import { ModalsProvider } from "@mantine/modals";
import { NotificationsProvider } from "@mantine/notifications";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import Auth0Provider from "./providers/auth/Auth0Provider";
import RouterProvider from "./providers/Router";
import AppTheme from "./themes/AppTheme";
import "./providers/HttpClient";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Treat data as fresh for 60s by default so React Query doesn't refetch
      // on every component mount — the previous default of 0 caused every
      // route change to re-issue queries even when the data was already cached.
      staleTime: 60_000,
      // Keep cached responses around for 5 minutes after the last subscriber
      // unmounts; lets returning users skip the loading spinner on back/forward.
      cacheTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      // One retry is enough — anything more masks real failures with latency.
      retry: 1,
    },
  },
});

const App = (): JSX.Element => (
  <QueryClientProvider client={queryClient}>
    <MantineProvider
      withNormalizeCSS
      withGlobalStyles
      theme={{
        colors: {
          "jem-theme": [
            "#ED7687",
            "#ED7687",
            "#ED7687",
            "#ED7687",
            "#ED7687",
            "#062133",
            "#ED7687",
            "#ED7687",
            "#ED7687",
            "#ED7687",
          ],
        },
        breakpoints: {
          xs: 600,
          sm: 768,
          md: 992,
          lg: 1200,
          xl: 1400,
        },
        fontFamily: "Inter",
        primaryColor: "jem-theme",
        focusRing: "never",
        black: "#495057",
        lineHeight: 1.5,
        fontSizes: {
          xs: 14,
          sm: 14,
          md: 14,
          lg: 14,
          xl: 14,
        },
      }}
      styles={AppTheme}
    >
      <NotificationsProvider autoClose={2000} position="top-right">
        <ModalsProvider
          modalProps={{
            radius: "md",
            shadow: "md",
          }}
        >
          <Auth0Provider>
            <RouterProvider />
          </Auth0Provider>
        </ModalsProvider>
      </NotificationsProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </MantineProvider>
  </QueryClientProvider>
);

export default App;
